import { render } from "./keyWord.vue?vue&type=template&id=24b662cb&lang=true"
import script from "./keyWord.vue?vue&type=script&lang=js"
export * from "./keyWord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__